import { ThemeConfig } from 'antd';
// https://ant.design/docs/react/customize-theme
export const classic: ThemeConfig = {
  token: {
    colorPrimary: '#E06636', //orange
    colorPrimaryBgHover: '#b5512a', // bg button primary hover
    colorFillSecondary: '#56AFDC', //bleu clair
    colorTextSecondary: '#009fc3',
    colorBorderSecondary: '#009fc3', // bg button secondary hover
    colorBgContainer: '#ffffff',
    colorBgBase: '#F0FDFD', // presque blanc
    colorText: '#4d4d4f', //presque noir
    colorFillAlter: '#f0f0f0',
    colorIcon: '#0B446F', //'#188',
    colorIconHover: '#0B446F', //'#188',
    colorLink: '#0B446F', // '#188',
    colorError: '#E7340E ',
    colorTextDisabled: '#0B446F',
    colorWhite: '#FFFFFF',
    colorInfoBg: '#262626B3', // couleur de bd de recapInfo
    fontFamily: '"PT Sans", sans-serif',
    colorSuccess: '#14b15c',
    colorWarning: '#dd6848',
  },
  components: {
    Input: {
      colorText: '#262626',
      colorTextPlaceholder: '#918f8a',
    },
    Modal: {
      colorText: '#4A4A4A',
    },
    Drawer: {
      colorText: '#000000',
    },
    Table: {
      colorText: '#000000',
    },
  },
};
